import { flamelinkUploadpassword } from "./flamelink"

let userData = [
    {
        "HANDLE": "@__herberth",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/__herberth/",
        "FIRST": "Aldo",
        "LAST": "André",
        "SCREEN_NAME": "A.ANDRÉ",
        "PASSWORD": "profiler-contracting"
    },
    {
        "HANDLE": "@_ajgirard",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/_ajgirard/",
        "FIRST": "AJ",
        "LAST": "Girard",
        "SCREEN_NAME": "A.GIRARD",
        "PASSWORD": "pocket-kilo"
    },
    {
        "HANDLE": "@_dr_woo_",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/_dr_woo_/",
        "FIRST": "Brian Kin",
        "LAST": "Woo",
        "SCREEN_NAME": "DR.WOO",
        "PASSWORD": "whatsoever-extrovert"
    },
    {
        "HANDLE": "@104_310",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/104_310/",
        "FIRST": "Toshi",
        "LAST": "SATO",
        "SCREEN_NAME": "T.SATO",
        "PASSWORD": "boiling-falter"
    },
    {
        "HANDLE": "@aaput",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/aaput/",
        "FIRST": "Nur",
        "LAST": "Safuraa Binti Abd Razak",
        "SCREEN_NAME": "N.SAFURAA BINTI ABD RAZAK",
        "PASSWORD": "vagabond-half"
    },
    {
        "HANDLE": "@acissssssej",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/acissssssej/",
        "FIRST": "Jessica",
        "LAST": "Martin",
        "SCREEN_NAME": "J.MARTIN",
        "PASSWORD": "piazza-surmount"
    },
    {
        "HANDLE": "@ale6ix_",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/ale6ix_/",
        "FIRST": "Alexis",
        "LAST": "Shelton",
        "SCREEN_NAME": "A.SHELTON",
        "PASSWORD": "phonics-inclement"
    },
    {
        "HANDLE": "@andrewhdunlap",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/andrewhdunlap/",
        "FIRST": "Andrew",
        "LAST": "Dunlap",
        "SCREEN_NAME": "A.DUNLAP",
        "PASSWORD": "saw-self"
    },
    {
        "HANDLE": "@ar.marianne",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/ar.marianne/",
        "FIRST": "Marianne S.",
        "LAST": "Mercado",
        "SCREEN_NAME": "M.MERCADO",
        "PASSWORD": "crotch-ferocity"
    },
    {
        "HANDLE": "@asaretzky",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/asaretzky/",
        "FIRST": "Alexander",
        "LAST": "Saretzky",
        "SCREEN_NAME": "A.SARETZKY",
        "PASSWORD": "relegate-sheen"
    },
    {
        "HANDLE": "@bbmeyer11",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/bbmeyer11/",
        "FIRST": "Baylie",
        "LAST": "Meyer",
        "SCREEN_NAME": "B.MEYER",
        "PASSWORD": "shower-wolf"
    },
    {
        "HANDLE": "@bd_concepts",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/bd_concepts/",
        "FIRST": "Brett",
        "LAST": "Drake",
        "SCREEN_NAME": "B.DRAKE",
        "PASSWORD": "judo-starlight"
    },
    {
        "HANDLE": "@beautymarkkj",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/beautymarkkj/",
        "FIRST": "Yuliany",
        "LAST": "Ramirez",
        "SCREEN_NAME": "Y.RAMIREZ",
        "PASSWORD": "corkscrew-blur"
    },
    {
        "HANDLE": "@benji_and_the_pack",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/benji_and_the_pack/",
        "FIRST": "Benji",
        "LAST": "Rothenberg",
        "SCREEN_NAME": "B.ROTHENBERG",
        "PASSWORD": "acquit-craziness"
    },
    {
        "HANDLE": "@bert_correa",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/bert_correa/",
        "FIRST": "Bert",
        "LAST": "Correa",
        "SCREEN_NAME": "B.CORREA JR",
        "PASSWORD": "thug-sweating"
    },
    {
        "HANDLE": "@borreakkersdijk",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/borreakkersdijk/",
        "FIRST": "Borre",
        "LAST": "Akkersdijk",
        "SCREEN_NAME": "B.AKKERSDIJK",
        "PASSWORD": "sauerkraut-diagonal"
    },
    {
        "HANDLE": "@bradgehlosu",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/bradgehlosu/",
        "FIRST": "Brad",
        "LAST": "Gehl",
        "SCREEN_NAME": "B.GEHL",
        "PASSWORD": "appropriateness-mixed"
    },
    {
        "HANDLE": "@brycesoncenter",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/brycesoncenter/",
        "FIRST": "Bryceson",
        "LAST": "Center",
        "SCREEN_NAME": "B.CENTER",
        "PASSWORD": "surgery-yeast"
    },
    {
        "HANDLE": "@bujw",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/bujw/",
        "FIRST": "Josh",
        "LAST": "Ward",
        "SCREEN_NAME": "J.WARD",
        "PASSWORD": "rehearsal-thriving"
    },
    {
        "HANDLE": "@caulin_tanner",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/caulin_tanner/",
        "FIRST": "Caulin",
        "LAST": "Tanner",
        "SCREEN_NAME": "C.TANNER",
        "PASSWORD": "chaste-institute"
    },
    {
        "HANDLE": "@charlies_copy",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/charlies_copy/",
        "FIRST": "Charlie",
        "LAST": "Tighe",
        "SCREEN_NAME": "C.TIGHE",
        "PASSWORD": "synonym-limit"
    },
    {
        "HANDLE": "@chasethelite/@weartester",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/chasethelite/@weartester/",
        "FIRST": "Anthony",
        "LAST": "Polanco",
        "SCREEN_NAME": "A.POLANCO",
        "PASSWORD": "ethanol-rudder"
    },
    {
        "HANDLE": "@chawan.dissertations/@nuevo.joe",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/chawan.dissertations/@nuevo.joe/",
        "FIRST": "Joseph",
        "LAST": "Au",
        "SCREEN_NAME": "J.AU",
        "PASSWORD": "lily-ration"
    },
    {
        "HANDLE": "@counting_meters/@___UK9",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/counting_meters/@___UK9/",
        "FIRST": "Joshua",
        "LAST": "Pietersen",
        "SCREEN_NAME": "A.PIETERSEN",
        "PASSWORD": "lusty-overextend"
    },
    {
        "HANDLE": "@coxmatthew96",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/coxmatthew96/",
        "FIRST": "Matthew",
        "LAST": "Cox",
        "SCREEN_NAME": "M.COX",
        "PASSWORD": "vigilant-spray"
    },
    {
        "HANDLE": "@craftswithhellen",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/craftswithhellen/",
        "FIRST": "Ellen",
        "LAST": "Meijer",
        "SCREEN_NAME": "E.MEIJER",
        "PASSWORD": "generalize-ration"
    },
    {
        "HANDLE": "@culturalprosthetics",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/culturalprosthetics/",
        "FIRST": "Matthijs",
        "LAST": "Geertjes",
        "SCREEN_NAME": "M.GEERTJES",
        "PASSWORD": "refill-immovable"
    },
    {
        "HANDLE": "@dapizzaproductions",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/dapizzaproductions/",
        "FIRST": "Isabela",
        "LAST": "Fraga-Abaza",
        "SCREEN_NAME": "I.FRAGA-ABAZA",
        "PASSWORD": "colonist-sophomore"
    },
    {
        "HANDLE": "@dbook",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/dbook/",
        "FIRST": "Devin",
        "LAST": "Booker",
        "SCREEN_NAME": "D.BOOKER",
        "PASSWORD": "eraser-methodist"
    },
    {
        "HANDLE": "@djmotherearth",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/djmotherearth/",
        "FIRST": "Amanda",
        "LAST": "Kobritz",
        "SCREEN_NAME": "A.KOBRITZ",
        "PASSWORD": "forebear-concomitant"
    },
    {
        "HANDLE": "@dommis.the.kid",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/dommis.the.kid/",
        "FIRST": "Dominic",
        "LAST": "Kemmeter",
        "SCREEN_NAME": "D.KEMMETER",
        "PASSWORD": "strait-florentine"
    },
    {
        "HANDLE": "@eaklass",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/eaklass/",
        "FIRST": "Emily",
        "LAST": "Klass",
        "SCREEN_NAME": "E.KLASS",
        "PASSWORD": "conduct-carpool"
    },
    {
        "HANDLE": "@easyotabor",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/easyotabor/",
        "FIRST": "Easy",
        "LAST": "Otabor",
        "SCREEN_NAME": "E.OTABOR",
        "PASSWORD": "calibrate-protective"
    },
    {
        "HANDLE": "@elenamars.weartester",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/elenamars.weartester/",
        "FIRST": "Elena",
        "LAST": "Rodriguez",
        "SCREEN_NAME": "E.RODRIGUEZ",
        "PASSWORD": "unsung-drift"
    },
    {
        "HANDLE": "@floppy.ferret",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/floppy.ferret/",
        "FIRST": "Graeme",
        "LAST": "Robinson",
        "SCREEN_NAME": "G.ROBINSON",
        "PASSWORD": "impinge-diorama"
    },
    {
        "HANDLE": "@gregism/cargocultmember",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/gregism/cargocultmember/",
        "FIRST": "Gregory",
        "LAST": "Smith",
        "SCREEN_NAME": "G.SMITH",
        "PASSWORD": "starter-numbered"
    },
    {
        "HANDLE": "@hannhnerz",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/hannhnerz/",
        "FIRST": "Hannah",
        "LAST": "Trimor",
        "SCREEN_NAME": "H.TRIMOR",
        "PASSWORD": "curatorial-liable"
    },
    {
        "HANDLE": "@harper_law",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/harper_law/",
        "FIRST": "Lawrence",
        "LAST": "Harper",
        "SCREEN_NAME": "L.HARPER",
        "PASSWORD": "questioning-spate"
    },
    {
        "HANDLE": "@hd.atk",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/hd.atk/",
        "FIRST": "LI",
        "LAST": "KAI",
        "SCREEN_NAME": "L.KAI",
        "PASSWORD": "kelvin-off"
    },
    {
        "HANDLE": "@imagineandworkforit",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/imagineandworkforit/",
        "FIRST": "Omar",
        "LAST": "García Azofra",
        "SCREEN_NAME": "O.GARCÍA AZOFRA",
        "PASSWORD": "preconception-sedition"
    },
    {
        "HANDLE": "@jakeydabakey",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/jakeydabakey/",
        "FIRST": "Jacob",
        "LAST": "Pawlak",
        "SCREEN_NAME": "J.PAWLAK",
        "PASSWORD": "hand-gaming"
    },
    {
        "HANDLE": "@jbodaway",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/jbodaway/",
        "FIRST": "JEFFREY",
        "LAST": "BAYARD",
        "SCREEN_NAME": "J.BAYARD",
        "PASSWORD": "underneath-nonexistent"
    },
    {
        "HANDLE": "@jerami.dean.goodwin",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/jerami.dean.goodwin/",
        "FIRST": "Jerami Dean",
        "LAST": "Goodwin",
        "SCREEN_NAME": "J.GOODWIN",
        "PASSWORD": "drip-cd"
    },
    {
        "HANDLE": "@jlopez.ph",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/jlopez.ph/",
        "FIRST": "Jennifer",
        "LAST": "Lopez",
        "SCREEN_NAME": "J.LOPEZ",
        "PASSWORD": "hodgepodge-detachment"
    },
    {
        "HANDLE": "@k.e.l.s.a",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/k.e.l.s.a/",
        "FIRST": "Kelsa",
        "LAST": "Kuchera",
        "SCREEN_NAME": "K.KUCHERA",
        "PASSWORD": "procreation-spiced"
    },
    {
        "HANDLE": "@kicks_and_kilos",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/kicks_and_kilos/",
        "FIRST": "Luke",
        "LAST": "Jenkinson",
        "SCREEN_NAME": "L.JENKINSON",
        "PASSWORD": "visualize-behavioural"
    },
    {
        "HANDLE": "@kuendalljenner",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/kuendalljenner/",
        "FIRST": "JENNIFER",
        "LAST": "WONG CHEE KUEN",
        "SCREEN_NAME": "J.WONG CHEE KUEN",
        "PASSWORD": "graft-hummus"
    },
    {
        "HANDLE": "@lartdelautomobile",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/lartdelautomobile/",
        "FIRST": "Arthur",
        "LAST": "Karakoumouchian",
        "SCREEN_NAME": "A.KARAKOUMOUCHIAN",
        "PASSWORD": "consumption-drip"
    },
    {
        "HANDLE": "@lawrentian.abyss",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/lawrentian.abyss/",
        "FIRST": "Christopher",
        "LAST": "Lawrence",
        "SCREEN_NAME": "C.LAWRENCE",
        "PASSWORD": "statutory-phenotypic"
    },
    {
        "HANDLE": "@liz_ncwt",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/liz_ncwt/",
        "FIRST": "Liz",
        "LAST": "Ward",
        "SCREEN_NAME": "L.WARD",
        "PASSWORD": "subspecies-subordination"
    },
    {
        "HANDLE": "@mennodrontmann",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/mennodrontmann/",
        "FIRST": "Menno",
        "LAST": "Drontmann",
        "SCREEN_NAME": "M.DRONTMANN",
        "PASSWORD": "ruling-hunger"
    },
    {
        "HANDLE": "@mikkocisco",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/mikkocisco/",
        "FIRST": "Mikko",
        "LAST": "Francisco",
        "SCREEN_NAME": "M.FRANCISCO",
        "PASSWORD": "processing-keel"
    },
    {
        "HANDLE": "@miles_hosanna",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/miles_hosanna/",
        "FIRST": "Miles",
        "LAST": "Hosanna",
        "SCREEN_NAME": "M.HOSANNA",
        "PASSWORD": "wearable-shower"
    },
    {
        "HANDLE": "@myknolling",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/myknolling/",
        "FIRST": "YONG SUK",
        "LAST": "PARK",
        "SCREEN_NAME": "Y.PARK",
        "PASSWORD": "reflective-proceedings"
    },
    {
        "HANDLE": "@normal_use",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/normal_use/",
        "FIRST": "Jack",
        "LAST": "Willis",
        "SCREEN_NAME": "J.WILLIS",
        "PASSWORD": "troubled-tau"
    },
    {
        "HANDLE": "@notjunrey",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/notjunrey/",
        "FIRST": "Jun Rey Rellon",
        "LAST": "Libutan",
        "SCREEN_NAME": "J.LIBUTAN",
        "PASSWORD": "retort-manageable"
    },
    {
        "HANDLE": "@pepiamstart",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/pepiamstart/",
        "FIRST": "Stella",
        "LAST": "Schwarzlaff",
        "SCREEN_NAME": "S.SCHWARZLAFF",
        "PASSWORD": "hidden-hierarchical"
    },
    {
        "HANDLE": "@quwutsunmade",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/quwutsunmade/",
        "FIRST": "Adrianna",
        "LAST": "Johnny-Wadsworth",
        "SCREEN_NAME": "A.JOHNNY-WADSWORTH",
        "PASSWORD": "timepiece-precipitously"
    },
    {
        "HANDLE": "@r.carlin_isru",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/r.carlin_isru/",
        "FIRST": "Ryan",
        "LAST": "Carlin",
        "SCREEN_NAME": "R.CARLIN",
        "PASSWORD": "endorsement-anti"
    },
    {
        "HANDLE": "@racingatelier",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/racingatelier/",
        "FIRST": "Leander",
        "LAST": "Angerer",
        "SCREEN_NAME": "L.ANGERER",
        "PASSWORD": "extinguish-cluttered"
    },
    {
        "HANDLE": "@raydoeksen",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/raydoeksen/",
        "FIRST": "Ray",
        "LAST": "Doeksen",
        "SCREEN_NAME": "R.DOEKSEN",
        "PASSWORD": "saddle-informative"
    },
    {
        "HANDLE": "@realphillytf",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/realphillytf/",
        "FIRST": "Clifford L",
        "LAST": "Holt III",
        "SCREEN_NAME": "C.HOLT III",
        "PASSWORD": "lithium-bake"
    },
    {
        "HANDLE": "@reprage",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/reprage/",
        "FIRST": "Clinton",
        "LAST": "Freeman",
        "SCREEN_NAME": "C.FREEMAN",
        "PASSWORD": "readout-unaware"
    },
    {
        "HANDLE": "@scribble_iz",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/scribble_iz/",
        "FIRST": "Izzy",
        "LAST": "Robinson",
        "SCREEN_NAME": "I.ROBINSON",
        "PASSWORD": "wispy-instructional"
    },
    {
        "HANDLE": "@sierradeltagolf",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/sierradeltagolf/",
        "FIRST": "Samuel",
        "LAST": "de Goede",
        "SCREEN_NAME": "S.DE GOEDE",
        "PASSWORD": "inflection-facility"
    },
    {
        "HANDLE": "@sitabellan",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/sitabellan/",
        "FIRST": "Sita",
        "LAST": "Abellan",
        "SCREEN_NAME": "S.ABELLÁN",
        "PASSWORD": "stocky-hoe"
    },
    {
        "HANDLE": "@skinnymacho",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/skinnymacho/",
        "FIRST": "Skinny",
        "LAST": "Macho",
        "SCREEN_NAME": "S.MACHO",
        "PASSWORD": "jolt-interchange"
    },
    {
        "HANDLE": "@sonyayu",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/sonyayu/",
        "FIRST": "Sonya",
        "LAST": "Yu",
        "SCREEN_NAME": "S.YU",
        "PASSWORD": "fry-nervously"
    },
    {
        "HANDLE": "@stokesmfg",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/stokesmfg/",
        "FIRST": "Bryce",
        "LAST": "Williamson",
        "SCREEN_NAME": "B.WILLIAMSON",
        "PASSWORD": "anarchy-regularity"
    },
    {
        "HANDLE": "@themartino3000",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/themartino3000/",
        "FIRST": "Dillon",
        "LAST": "Martino",
        "SCREEN_NAME": "D.MARTINO",
        "PASSWORD": "turd-bazaar"
    },
    {
        "HANDLE": "@tomwoodger",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/tomwoodger/",
        "FIRST": "Tom",
        "LAST": "Woodger",
        "SCREEN_NAME": "T.WOODGER",
        "PASSWORD": "commend-handlebar"
    },
    {
        "HANDLE": "@tristanclor",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/tristanclor/",
        "FIRST": "Tristan",
        "LAST": "Clor",
        "SCREEN_NAME": "T.CLOR",
        "PASSWORD": "unmanned-pastime"
    },
    {
        "HANDLE": "@v2d2_",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/v2d2_/",
        "FIRST": "Valorie",
        "LAST": "Reyes",
        "SCREEN_NAME": "V.REYES",
        "PASSWORD": "ounce-date"
    },
    {
        "HANDLE": "@white1977",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/white1977/",
        "FIRST": "Josh",
        "LAST": "White",
        "SCREEN_NAME": "J.WHITE",
        "PASSWORD": "dial-braid"
    },
    {
        "HANDLE": "@wyweb",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/wyweb/",
        "FIRST": "Wyatt",
        "LAST": "Weber",
        "SCREEN_NAME": "W.WEBER",
        "PASSWORD": "accessible-ahold"
    },
    {
        "HANDLE": "@xin_liu_studio",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/xin_liu_studio/",
        "FIRST": "Xin",
        "LAST": "Liu",
        "SCREEN_NAME": "X.LIU",
        "PASSWORD": "possessive-ultra"
    },
    {
        "HANDLE": "@yy_ncweartester",
        "LINK_TO_IG_HANDLE": "https://www.instagram.com/yy_ncweartester/",
        "FIRST": "Yusuke",
        "LAST": "Yamagiwa",
        "SCREEN_NAME": "Y.YAMAGIWA",
        "PASSWORD": "lazily-prolonged"
    },
    {
        "HANDLE": "",
        "LINK_TO_IG_HANDLE": "",
        "FIRST": "Rebekah",
        "LAST": "Birkan",
        "SCREEN_NAME": "R.BIRKAN",
        "PASSWORD": "dive-uniformed"
    },
    {
        "HANDLE": "",
        "LINK_TO_IG_HANDLE": "",
        "FIRST": "Arthur",
        "LAST": "Sachs",
        "SCREEN_NAME": "A.SACHS",
        "PASSWORD": "abductor-balloting"
    },
    {
        "HANDLE": "@imisaac",
        "LINK_TO_IG_HANDLE": "",
        "FIRST": "Isaac",
        "LAST": "Rivera",
        "SCREEN_NAME": "I.RIVERA",
        "PASSWORD": "nativity-slit"
    },
    {
        "HANDLE": "@anzo.wip",
        "LINK_TO_IG_HANDLE": "",
        "FIRST": "Andy",
        "LAST": "Anzollitto",
        "SCREEN_NAME": "A.ANZOLLITTO",
        "PASSWORD": "regroup-swoop"
    },
    {
        "HANDLE": "@fakesickness",
        "LINK_TO_IG_HANDLE": "",
        "FIRST": "KB",
        "LAST": "",
        "SCREEN_NAME": "KB",
        "PASSWORD": "navel-grunting"
    }
]


/*
    "HANDLE": "@__herberth",
    "LINK_TO_IG_HANDLE": "https://www.instagram.com/__herberth/",
    "FIRST": "Aldo",
    "LAST": "André",
    "SCREEN_NAME": "A.ANDRÉ",
    "PASSWORD": "profiler-contracting"
}
*/

export function uploadUsersToFlamelink() {
    userData.forEach(user => {
        flamelinkUploadpassword(user)
    })
}

